import { Record, type RecordOf } from 'immutable';
import type { QcsSyncResourceStore } from '../core/resourceStoreTypes';
export const REDUCER_KEY = 'reportConfigurationsStore';
export type REDUCER_KEY = typeof REDUCER_KEY;

export type AccountingType = 'ACCRUAL' | 'CASH';

export type ReportConfigurationProps = {
  id?: string;
  clientId?: string;

  name?: string;
  description?: string;

  reportType?: string; // COMPARISON, SUMMARY, TRANSACTION
  reportSubType?: string; // INCOME, NET_INCOME, NET_WORTH, SPENDING, TAX
  accountingType?: AccountingType;

  dateRange?: string; // THIS_YEAR, ETC.
  startOn?: string;
  endOn?: string;

  rowType?: string; // ACCOUNT, CATEGORY, ENTITY_BUSINESS, ENTITY_CLIENT, ENTITY_PROJECT, PAYEE, TAG, TAX_LINE_ITEM, TAX_SCHEDULE
  columnType?: string; // ACCOUNT, DATE_RANGE, ENTITY_BUSINESS, ENTITY_CLIENT, ENTITY_PROJECT, PAYEE, TAG
  timestep?: string; // MONTH, ETC.

  filterId?: string;
  filter?: any;

  isDeleted?: boolean;
  modifiedAt?: string;

  showSubTotalsOnBottom?: boolean;
  showSubTotalLabel?: boolean;
};
export type ReportConfiguration = RecordOf<ReportConfigurationProps>;
export const mkReportConfiguration = Record<ReportConfigurationProps>({
  id: undefined,
  clientId: undefined,

  name: undefined,
  description: undefined,

  reportType: undefined,
  reportSubType: undefined,
  accountingType: undefined,

  dateRange: undefined,
  startOn: undefined,
  endOn: undefined,

  columnType: undefined,
  rowType: undefined,
  timestep: undefined,

  filterId: undefined,
  filter: undefined,

  isDeleted: undefined,
  modifiedAt: undefined,

  showSubTotalsOnBottom: undefined,
  showSubTotalLabel: undefined,
});

declare module 'app-components/utils/redux-store/rootState' {
  export default interface RootState {
    [REDUCER_KEY]: QcsSyncResourceStore<ReportConfigurationProps>;
  }
}
